// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.charts-page {
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.charts-page-body {
  display: flex;
  flex: 1 1;
  gap: 20px;
  padding-bottom: 24px;
}

.charts-page-tabs {
  flex: 3 1;
  min-width: 0;
}

.charts-page-info {
  flex: 1 1;
  min-width: 0;
}

@media (max-width: 992px) {
  .charts-page-body {
    flex-direction: column;
  }
  .charts-page-info {
    flex: 1 1;
  }
}

@media (max-width: 480px) {
  .charts-page {
    padding: 12px;
  }
  .charts-page-body {
    gap: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ChartsPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAO;EACP,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,SAAO;EACT;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;AACF","sourcesContent":[".charts-page {\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n}\n\n.charts-page-body {\n  display: flex;\n  flex: 1;\n  gap: 20px;\n  padding-bottom: 24px;\n}\n\n.charts-page-tabs {\n  flex: 3;\n  min-width: 0;\n}\n\n.charts-page-info {\n  flex: 1;\n  min-width: 0;\n}\n\n@media (max-width: 992px) {\n  .charts-page-body {\n    flex-direction: column;\n  }\n  .charts-page-info {\n    flex: 1;\n  }\n}\n\n@media (max-width: 480px) {\n  .charts-page {\n    padding: 12px;\n  }\n  .charts-page-body {\n    gap: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
